module.exports = __webpack_public_path__ + "static/pfagoraslabpro-thin.ded70f47.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/pfagoraslabpro-thin.ttf
// module id = 325
// module chunks = 114276838955818